import { useMemo, useState } from "react";
import { channels, newsFeed } from "@/mocks/news";

const catMap: Record<string, string> = {
  突发: "突发直击",
  城市: "城市现场",
  体育: "体育现场",
  文娱: "文娱现场",
  科技: "科技前沿",
};

export default function Channels() {
  const [active, setActive] = useState(channels[0]);

  const list = useMemo(
    () => (active === "全部" ? newsFeed : newsFeed.filter((n) => catMap[n.cat] === active)),
    [active]
  );

  return (
    <section id="channels" className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
        <div>
          <p className="text-primary-600 text-xs font-semibold tracking-[0.25em] mb-2">CHANNELS · 栏目速递</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">分类直击现场</h2>
        </div>
        <div className="flex items-center gap-1 flex-wrap rounded-full border border-background-200 bg-background-100 p-1 w-fit">
          {channels.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {list.map((item) => (
          <article key={item.id} className="group flex flex-col rounded-lg border border-background-200 bg-background-100 overflow-hidden hover:border-primary-300 transition-colors">
            <a href="#channels" className="relative overflow-hidden block aspect-[3/2] w-full">
              <img
                src={item.image}
                alt={`${item.title} 现场图片`}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-2.5 left-2.5 rounded-full bg-black/55 backdrop-blur text-background-50 text-[10px] px-2.5 py-1 inline-flex items-center gap-1">
                <i className="ri-map-pin-2-line" /> {item.location}
              </span>
              <span className="absolute bottom-2.5 left-2.5 rounded bg-primary-500 text-background-50 text-[11px] px-2 py-0.5 font-medium">
                {item.tag}
              </span>
            </a>
            <div className="flex flex-col flex-1 p-4">
              <h3 className="font-heading text-[15px] leading-snug font-bold text-foreground-950 group-hover:text-primary-700 line-clamp-2">
                {item.title}
              </h3>
              <p className="mt-2 text-[13px] text-foreground-600 leading-relaxed line-clamp-2">{item.excerpt}</p>
              <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-[11px] text-foreground-400">
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {item.views}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-time-line" /> {item.time}</span>
                <span className="inline-flex items-center gap-1 text-primary-500"><i className="ri-arrow-right-line" /> 进入现场</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}